<script>
export const group = 'Bottom'
</script>

<script setup>
import AnimatedSkewedEllipsMaskWithEnergeticFrequencies from './shared/AnimatedSkewedEllipsMaskWithEnergeticFrequencies.vue'
import PhoneIcon from '../../../assets/icons/phone.svg?url_encode'
import AnimatedSkewedEllipsMask from './shared/AnimatedSkewedEllipsMask.vue'
import TwoLineLowerThird from './shared/TwoLineLowerThird.vue'
import { onMounted } from 'vue'
import VideoPlayer from '../../VideoPlayer.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const data = ref({
  name: null,
  image: null,
})

const setData = async (callContact) => {
  data.value.name = callContact?.name || null
  data.value.image = callContact?.imageUrl || null

  await nextTick()
}

const iconRef = ref(null)
const ovalCallRef = ref(null)

const iconTimeline = ref(null)
const iconDisappearTimeline = ref(null)

const callContactTimeline = ref(null)
const callContactDisappearTimeline = ref(null)

const callNameTimeline = ref(null)
const callNameDisappearTimeline = ref(null)

const doAppear = async () => {
  const timeline = gsapTimeline({ name: 'PhoneCallSmall' }).add(iconTimeline).to(ovalCallRef.value, { opacity: 0, duration: 0.2, delay: 2.5 }).add(callNameTimeline, 2.4).add(callContactTimeline, 2.5)

  if (callContactTimeline.value) {
    timeline.to(iconRef.value.$el, { duration: 0.1, opacity: 0 })
  }
}

const doDisappear = async () => {
  return gsapTimeline({ name: 'PhoneCallSmall - Disappear' }).add(iconDisappearTimeline, 0).add(callNameDisappearTimeline).add(callContactDisappearTimeline, 0.1)
}

onMounted(async () => {
  iconTimeline.value.kill()
  callContactTimeline.value?.kill()
  callNameTimeline.value?.kill()

  await setData(props.item?.enrichment?.callContact)
  await doAppear()
})

const { onDisappear } = useDisappearable()
onDisappear(doDisappear)

watch(
  () => props.item?.enrichment?.callContact,
  async (newCallContact) => {
    const { name: newName, imageUrl: newImage } = newCallContact || {}
    const { name: currentName, image: currentImage } = data.value

    const timeline = gsapTimeline({ name: 'PhoneCallSmall - Update' })

    if (currentName && newName !== currentName) {
      timeline.add(callNameDisappearTimeline)
    }

    if (currentImage && newImage !== currentImage) {
      timeline.to(iconRef.value.$el, { duration: 0.1, opacity: 1 })
      timeline.add(callContactDisappearTimeline)
    }

    await timeline.to({}, {})
    await setData(newCallContact)

    if (newName) {
      timeline.add(callNameTimeline)
    }

    if (newImage) {
      timeline.add(callContactTimeline)
      timeline.to(iconRef.value.$el, { duration: 0.1, opacity: 0 })
    }

    await timeline.to({}, {})
  }
)
</script>

<template>
  <VideoPlayer ref="ovalCallRef" class="absolute bottom-0 z-10 -ml-6 mb-1" src="../../../assets/animations/energetic_frequencies/skewed_oval_call.webm" />
  <div class="absolute bottom-0 p-safe z-20 ml-5 mb-5">
    <AnimatedSkewedEllipsMaskWithEnergeticFrequencies
      ref="iconRef"
      :inFrequencies="false"
      class="scale-50 origin-bottom-left"
      loopFrequencies
      @timeline="iconTimeline = $event"
      @disappearTimeline="iconDisappearTimeline = $event"
    >
      <div class="w-full h-full bg-q-cr-red-primary flex items-center justify-center">
        <img :src="PhoneIcon" class="w-20 h-20" />
      </div>
    </AnimatedSkewedEllipsMaskWithEnergeticFrequencies>
  </div>
  <div v-if="data.image" class="absolute bottom-0 p-safe z-20">
    <AnimatedSkewedEllipsMask class="scale-75 origin-bottom-left ml-[20px]" @timeline="callContactTimeline = $event" @disappearTimeline="callContactDisappearTimeline = $event">
      <div class="w-full h-full bg-q-cr-red-primary flex items-center justify-center">
        <img :src="data.image" class="w-64 h-64 object-cover" />
      </div>
    </AnimatedSkewedEllipsMask>
  </div>
  <TwoLineLowerThird
    v-if="data.name"
    :key="data.name"
    title="Nu in de show"
    :line="data.name"
    class="ml-[250px]"
    @timeline="callNameTimeline = $event"
    @timelineOut="callNameDisappearTimeline = $event"
  />
</template>
